import classNames from "classnames"
import React from "react"
import { Card, CardBody, Collapse } from "reactstrap"
import SimpleBar from "simplebar-react"
import { useTranslation } from "react-i18next"

const DisputeHistory = ({
  openAccordion,
  setOpenAccordion,
  disputeHistory,
}: {
  openAccordion: boolean
  setOpenAccordion: React.Dispatch<React.SetStateAction<boolean>>
  disputeHistory: object[]
}) => {
  const { t } = useTranslation()

  return (
    <div className="accordion" id="accordion">
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingOne">
          <button
            className={classNames("accordion-button", "fw-medium", {
              collapsed: !openAccordion,
            })}
            type="button"
            onClick={() => setOpenAccordion(!openAccordion)}
            style={{ cursor: "pointer" }}
          >
            {t("disputes_disputeHistory")}
          </button>
        </h2>
        <Collapse isOpen={openAccordion} className="accordion-collapse">
          <div className="accordion-body">
            <Card className="shadow-md rounded-3">
              <CardBody className="p-2">
                <SimpleBar className="mt-3">
                  <ul className="verti-timeline list-unstyled">
                    {disputeHistory.map((item: any, index: number) => (
                      <li className="event-list" key={index}>
                        <div className="event-timeline-dot">
                          <span
                            className="rounded-circle bg-primary d-block"
                            style={{
                              width: "10px",
                              height: "10px",
                              marginLeft: "3px",
                            }}
                          ></span>
                        </div>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <div>
                              <b>{item.status}</b>
                              <p className="mb-0 text-muted">{item.date}</p>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </SimpleBar>
              </CardBody>
            </Card>
          </div>
        </Collapse>
      </div>
    </div>
  )
}

export default DisputeHistory
